import { Component, Inject } from "@angular/core";
import { FormControl, FormGroup } from "@angular/forms";
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";

@Component({
  selector: 'app-scope-comment-dialog',
  templateUrl: './scope-comment-dialog.component.html'
})
export class ScopeCommentDialog {
  form = new FormGroup({
    comment: new FormControl<string>(null)
  })

  constructor(
    public dialogRef: MatDialogRef<ScopeCommentDialog>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    if (data && data.comment) {
      this.form.patchValue({
        comment: data.comment
      })
    }
  }

  onClose() {
    this.dialogRef.close()
  }

  onSubmit() {
    const controls = this.form.controls
    const comment = controls.comment.value
    this.dialogRef.close({
      comment
    })
  }
}